require('ta-semantic-ui/semantic/dist/components/card.css');
require('ta-semantic-ui/semantic/dist/components/image.css');
require('ta-semantic-ui/semantic/dist/components/divider.css');
require('ta-semantic-ui/semantic/dist/components/modal.css');
require('./list.scss')

import React, { Component } from 'react';
import Item from '../item/Item'
import Modal from '../modal/Modal'

const propTypes = {
  itemData: React.PropTypes.array.isRequired
  };

class List extends Component {
  constructor(props) {
    super(props)
  }
  render() {
    return (
      <div className="ui raised card">
      
              <div className="content">
                  <div className="header">Liste {this.props.itemData.number}: <br />{this.props.itemData.name}</div>
              </div>
              
              <div className="content">
                <div className="ui divided items">
                  {
                    this.props.itemData.candidates.map((item, index) => {
                      let thisItem = item;
                      let thisIndex = index
                      return (
                        <div key={index}>
                            
                            <Item   data={thisItem}
                                    candidatesName={thisItem.name}
                                    candidatesImage={thisItem.img}
                                    party={thisItem.party}
                                    showModal={this.showModal}
                                    id = {index}
                                    key={index + 1} >
                              
                              
                          
                            </Item>
                        
                        </div>
                              )
                    })

                  }
                </div>
                
         </div>
      </div>
      )
  }
}

List.propTypes = propTypes

export default List






// WEBPACK FOOTER //
// ./src/components/custom/list/List.js